import { SxProps, Theme } from '@mui/material';

interface FilterPanelStyleProps {
  showFilters: boolean;
}

export const filterPanelStyles = {
  panel: (props: FilterPanelStyleProps) => ({
    width: props.showFilters ? 320 : 0,
    overflow: 'hidden',
    transition: 'width 0.3s',
    borderRadius: '4px 0 0 4px',
    display: 'flex',
    flexDirection: 'column'
  }),
  
  container: {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden'
  } as SxProps<Theme>,
  
  content: {
    flexGrow: 1,
    overflow: 'auto'
  } as SxProps<Theme>
}; 